import type { api } from "@breakout/backend/convex/_generated/api"
import type { FunctionReturnType } from "convex/server"
import type { Address } from "viem"

export const marketKeys = {
	all: ["breakout"] as const,
	markets: () => [...marketKeys.all, "markets"] as const,
	market: (address: Address) => [...marketKeys.markets(), address] as const,
	marketPrices: (address: Address) => [...marketKeys.market(address), "prices"] as const,
	marketShares: (address: Address, user: Address) =>
		[...marketKeys.market(address), "shares", user] as const,
	marketConfig: (address: Address) => [...marketKeys.market(address), "config"] as const,
	marketResolution: (address: Address) => [...marketKeys.market(address), "resolution"] as const,
	marketHasClaimed: (address: Address, user: Address) =>
		[...marketKeys.market(address), "claimed", user] as const,
	marketFees: (address: Address) => [...marketKeys.market(address), "fees"] as const,
	marketPreviewClaim: (address: Address, user: Address) =>
		[...marketKeys.market(address), "previewClaim", user] as const,
	marketBalance: (address: Address) => [...marketKeys.market(address), "balance"] as const,
	quote: (address: Address, type: "buy" | "sell", mask: number, shares: bigint) =>
		[...marketKeys.market(address), "quote", type, mask, shares.toString()] as const,
	// User positions across all markets for a week
	userPositions: (user: Address, weekId: string) =>
		[...marketKeys.all, "userPositions", user, weekId] as const,
	// Partial key for invalidation (matches all weeks for a user)
	allUserPositions: (user: Address) => [...marketKeys.all, "userPositions", user] as const,
} as const

export interface MarketPrices {
	prices: number[]
	normalized: number[]
}

type UserPositionsResult = FunctionReturnType<
	typeof api.domains.markets.actions.getUserPositionsForWeek
>
export type UserPosition = UserPositionsResult["positions"][number]
